import { render, staticRenderFns } from "./MainTicketing.vue?vue&type=template&id=2431d746"
import script from "./MainTicketing.vue?vue&type=script&lang=ts"
export * from "./MainTicketing.vue?vue&type=script&lang=ts"
import style0 from "./MainTicketing.vue?vue&type=style&index=0&id=2431d746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports